import { createContext } from 'react';
const ViewLabelTooltipContext = createContext(false);
export default ViewLabelTooltipContext;
